import { __assign, __extends } from "tslib";
import React from "react";
export var createContextHOC = function (Consumer) {
    var withContext = function (Component) {
        return /** @class */ (function (_super) {
            __extends(WithContextHOC, _super);
            function WithContextHOC() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                // TS: Property 'renderComponent' of exported class expression may not be private or protected.
                _this.renderComponent = function (ctx) {
                    var newProps = __assign(__assign({}, ctx), _this.props);
                    return React.createElement(Component, __assign({}, newProps));
                };
                return _this;
            }
            WithContextHOC.prototype.render = function () {
                return React.createElement(Consumer, null, this.renderComponent);
            };
            return WithContextHOC;
        }(React.Component));
    };
    return withContext;
};
//# sourceMappingURL=createContextHOC.js.map